import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BankAccount } from '../models/bankAccount.model';
import { RestResponse } from '../models/restResponse.mode';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BankAccountService {
  private readonly baseUrl = `${environment.base_url}/bankaccounts`;

  constructor(private http: HttpClient) {}

  list(search: string = '', active?: boolean, page: number = 1): Observable<RestResponse<BankAccount[]>> {
    let params: any = { search, page: page.toString() };
    if (active !== undefined) params.active = active.toString();
    return this.http.get<RestResponse<BankAccount[]>>(`${this.baseUrl}/list`, {
      params
    });
  }

  find(id: number): Observable<RestResponse<BankAccount>> {
    return this.http.get<RestResponse<BankAccount>>(`${this.baseUrl}/find/${id}`);
  }

  create(bankAccount: any): Observable<RestResponse<object>> {
    return this.http.post<RestResponse<object>>(`${this.baseUrl}/create`, bankAccount);
  }

  update(id: number, bankAccount: BankAccount): Observable<RestResponse<object>> {
    return this.http.put<RestResponse<object>>(`${this.baseUrl}/update/${id}`, bankAccount);
  }

  delete(id: number): Observable<RestResponse<void>> {
    return this.http.delete<RestResponse<void>>(`${this.baseUrl}/delete/${id}`);
  }
} 